import React, { useRef } from "react";
import { Icon } from "@iconify/react";

function InfoBox({ children, variant = "info" }) {
  return (
    <div className={`wa-tpl-info-box ${variant === "success" ? "wa-tpl-info-box--success" : ""}`}>
      <Icon icon="solar:info-circle-linear" width={18} />
      <ul>{children}</ul>
    </div>
  );
}

export default function TemplateCatalogStep({ form, updateForm }) {
  const thumbInputRef = useRef(null);

  return (
    <>
      <div className="wa-tpl-alert-banner">
        Catalog templates let customers browse your product catalog directly in WhatsApp.
        A &quot;View Catalog&quot; button is added automatically.
      </div>

      <div className="wa-tpl-field">
        <span>Catalog Thumbnail Image (Optional)</span>
        <div className="wa-tpl-upload-row">
          <button
            type="button"
            className="wa-tpl-btn-outline wa-tpl-upload-btn"
            onClick={() => thumbInputRef.current?.click()}
          >
            <Icon icon="solar:upload-linear" width={16} />
            Upload Thumbnail
          </button>
          {form.catalogThumbnailFile ? (
            <span className="wa-tpl-uploaded-chip">
              <Icon icon="solar:check-circle-linear" width={16} />
              Uploaded
              <button
                type="button"
                className="wa-tpl-icon-btn"
                onClick={() => updateForm({ catalogThumbnailFile: null })}
                aria-label="Remove thumbnail"
              >
                <Icon icon="solar:close-circle-linear" width={16} />
              </button>
            </span>
          ) : null}
          <input
            ref={thumbInputRef}
            type="file"
            className="d-none"
            accept="image/jpeg,image/png,image/webp"
            onChange={(e) =>
              updateForm({ catalogThumbnailFile: e.target.files?.[0] || null })
            }
          />
        </div>
        {form.catalogThumbnailFile ? (
          <div className="wa-tpl-thumb-preview">
            <img
              src={URL.createObjectURL(form.catalogThumbnailFile)}
              alt="Thumbnail preview"
            />
          </div>
        ) : null}
      </div>

      <label className="wa-tpl-field">
        <span>Message body *</span>
        <textarea
          className="wa-tpl-textarea"
          rows={5}
          maxLength={1024}
          value={form.bodyText}
          onChange={(e) => updateForm({ bodyText: e.target.value })}
          placeholder="Enter your message body..."
        />
        <small>{form.bodyText.length}/1024</small>
      </label>

      <label className="wa-tpl-field">
        <span>Footer (optional)</span>
        <input
          type="text"
          maxLength={60}
          value={form.footerText}
          onChange={(e) => updateForm({ footerText: e.target.value })}
          placeholder="Footer text"
        />
        <small>{form.footerText.length}/60</small>
      </label>

      <InfoBox>
        <li>Your Meta Business catalog must be linked and approved</li>
        <li>The &quot;View Catalog&quot; button is added automatically</li>
        <li>Thumbnail image is optional but improves engagement</li>
        <li>Catalog templates require MARKETING category</li>
      </InfoBox>
    </>
  );
}
